module.exports = __webpack_public_path__ + "img/pypj_l.bcb81b0d.png";